import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { useCallback, useMemo } from 'react';

import { useRudderStack } from '@ocx/data-analytics';

import {
  ExternalBannerDetailsPopupController,
  ExternalBannerDetailsPopupControllerProps,
} from './external-banner-details-popup.controller';

const ExternalBannerDetailsPopupModal = NiceModal.create(ExternalBannerDetailsPopupController);

export const useExternalBannerDetailsPopup = () => {
  const { show } = useModal(ExternalBannerDetailsPopupModal);
  const { triggerEvent } = useRudderStack();

  const open = useCallback(
    (props: ExternalBannerDetailsPopupControllerProps) => {
      triggerEvent('external_offer_details_modal_opened', { uuid: props.banner.trackingId });
      show(props);
    },
    [show, triggerEvent],
  );
  return useMemo(() => ({ open }), [open]);
};
